export default __webpack_public_path__ + "static/Montserrat-Bold-50f0257aa1e905f4bfaf64dc290accb9.ttf";